import { useState } from 'react'
import NavItemList from './NavItemList'
import Icon from './Icon'

interface NavBarProps {
  role: string
  onCollapse?: (isCollapsed: boolean) => void
  isCollapsed?: boolean
  isMobile?: boolean
}

export const NavBar = ({
  role,
  onCollapse,
  isCollapsed: externalIsCollapsed,
  isMobile,
}: NavBarProps) => {
  const [internalIsCollapsed, setInternalIsCollapsed] = useState(false)
  const isCollapsed = externalIsCollapsed ?? internalIsCollapsed

  const toggleCollapse = () => {
    if (isMobile) return
    const newState = !isCollapsed
    setInternalIsCollapsed(newState)
    onCollapse?.(newState)
  }

  return (
    <nav id="nav-bar" className={isMobile ? 'mobile' : ''}>
      <div className="top-bar-nav">
        <div className="logo">
          <img className="logo-image light-theme-only" src="/images/logo.png" alt="logo" />
          <img
            className="logo-image-white dark-theme-only"
            src="/images/logo-white.png"
            alt="logo"
          />
        </div>
      </div>
      <div className="position-sticky pt-md-5">
        {!isMobile && (
          <div className="collapse-button">
            <Icon name="AnglesLeft" onClick={toggleCollapse} />
          </div>
        )}
        <div className="nav-wrapper">
          <NavItemList role={role} isCollapsed={isCollapsed} isMobile={isMobile}></NavItemList>
        </div>
      </div>
    </nav>
  )
}

export default NavBar
